export default __webpack_public_path__ + "static/media/8OrionPharmaceuticalsLtd.(Tejgaon Project).808a1e8c.jpg";